import React from "react";
import "../Styles/Consulting.css";
import {
  FaDraftingCompass, FaExchangeAlt, FaNetworkWired, FaLightbulb,
  FaBatteryFull, FaProjectDiagram, FaSolarPanel, FaMicrochip,
  FaBolt, FaServer, FaFileAlt, FaWifi, FaFire, FaRegLightbulb, FaShieldAlt
} from 'react-icons/fa';

import DesignTop from "../../Asserts/consultation.png";
import Circle1 from "../../Asserts/circle1.png";
import Circle2 from "../../Asserts/circle2.png";
import Circle3 from "../../Asserts/circle3.png";
import Circle4 from "../../Asserts/circle4.png";
import Circle5 from "../../Asserts/circle5.png";
import SupplyImg from "../../Asserts/consultation2.png";

const Consulting = () => {
  const designServices = [
    { text: "Power system design & analysis", icon: <FaBolt /> },
    { text: "Transformer and switch gear selection", icon: <FaExchangeAlt /> },
    { text: "Cable routing & earthing systems", icon: <FaNetworkWired /> },
    { text: "Lighting & small power design", icon: <FaLightbulb /> },
    { text: "Generator & UPS integration", icon: <FaBatteryFull /> },
    { text: "Substation and distribution system layout", icon: <FaProjectDiagram /> },
    { text: "Renewable energy systems", icon: <FaSolarPanel /> },
    { text: "Instrumentation and interface with PLC/DCS/SCADA", icon: <FaMicrochip /> },
  ];

  const supplyServices = [
    { text: "Substation up to 110kV", icon: <FaBolt /> },
    { text: "Receiving station, Transformer, DG Sets, Electrical panels, Busduct, Cable management", icon: <FaServer /> },
    { text: "Liasoning and approvals", icon: <FaFileAlt /> },
    { text: "ELV System", icon: <FaWifi /> },
    { text: "Fire Protection System", icon: <FaFire /> },
    { text: "Outdoor and indoor lighting", icon: <FaRegLightbulb /> },
    { text: "Lightning Protection System", icon: <FaShieldAlt /> },
  ];

  const stripImages = [Circle1, Circle2, Circle3, Circle4, Circle5];

  return (
    <div className="services-container">

      {/* DESIGN & CONSULTING */}
      <div className="section design-section">
        <h2 className="section-title"><span className="highlight-orange">DESIGN</span> & CONSULTING</h2>

        <div className="design-content">
          <div className="service-list">
            {designServices.map((item, index) => (
              <div key={index} className="service-item">
                <span className="arrow-bullet">{item.icon}</span>
                <p>{item.text}</p>
              </div>
            ))}
          </div>

          <div className="design-visuals">
            <img src={DesignTop} alt="Design" className="design-illustration" />
          </div>
        </div>

        <div className="photo-strip">
          {stripImages.map((img, i) => (
            <img key={i} src={img} alt="" className="strip-img" />
          ))}
        </div>
      </div>

      <hr className="section-separator" />

      {/* SUPPLY, INSTALLATION, COMMISSIONING */}
      <div className="section supply-section">
        <h2 className="section-title">SUPPLY, <span className="highlight-orange">INSTALLATION</span>, COMMISSIONING</h2>

        <div className="supply-content">
          <div className="supply-visuals">
            <div className="hex-wrapper">
              <img src={SupplyImg} alt="Electrical panel" className="supply-illustration" />
            </div>
          </div>

          <div className="service-list">
            {supplyServices.map((item, index) => (
              <div key={index} className="service-item">
                <span className="arrow-bullet">{item.icon}</span>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default Consulting;
